import { AGENT_TYPE } from "src/app/product-capture/model/consts/agent-type.const";
import { TableCols } from "../interfaces/static-data";

export const AGENTS: TableCols[] = [
    {
        key: 'type',
        displayValue: 'Type',
        type: 'select',
        items: AGENT_TYPE,
        selectOptions: {
            searchable: true
        }
    },
    {
        key: 'entityName',
        displayValue: 'Entity Name',
    },
    {
        key: 'lei',
        displayValue: 'LEI'
    }
]

export interface Agent {
    id: number;
    type: string;
    entityName: string;
    lei?: string;
    productId?: string;
}

export interface AgentEntity {
    entityName: string;
    lei?: string;
}